<p-toast></p-toast>
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="{{translations.lbl_loading}}" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- MAIN CARD -->
<div class="card">

    <!-- TOOLBAR -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
                (click)="goBack()"></button>
        </ng-template>
    </p-toolbar>

    <!-- TABLE -->
    <p-table #dt [value]="lstSchoolsFpg" [columns]="lstCols" selectionMode="single" dataKey="vin" [rows]="10"
        [paginator]="true"
        [globalFilterFields]="['schoolFPG.period','schoolFPG.year','schoolFPG.name','guideName','schoolFPG.planedDate','storeName','statusName','schoolFPG.schoolId']"
        [rowHover]="true" dataKey="wrksId"
        currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_of}} {last} {{translations.lbl_records}}" [showCurrentPageReport]="true"
        responsive="true">

        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-center p-jc-between">                
                <h5 class="p-m-0">{{translations.lbl_school_prep_guides}} - {{selStore && selStore.descri?selStore.descri:" "}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{translations.lbl_search}}..." />
                </span>
            </div>
            <span class="p-input-icon-left">
                <button type="button" pButton pRipple icon="pi pi-plus" (click)="openNewSchoolFpgDetail()"                   
                    class="p-mr-4 z-5" pTooltip="{{translations.lbl_new_record}}" tooltipPosition="bottom"></button>

                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                    class="p-button-success p-mr-2 z-5" pTooltip="XLS" tooltipPosition="bottom"></button>
                <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                    class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
            </span>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="schoolFPG.schoolId">{{this.translations.lbl_id}}<p-sortIcon field="schoolFPG.schoolId"></p-sortIcon>
                </th>
                <th pSortableColumn="schoolFPG.year">{{this.translations.lbl_period}}<p-sortIcon field="schoolFPG.year"></p-sortIcon>
                </th>
                <th pSortableColumn="schoolFPG.name">{{this.translations.lbl_name}}<p-sortIcon field="schoolFPG.name"></p-sortIcon>
                </th>
                <th pSortableColumn="schoolFPG.name">{{this.translations.lbl_place}}<p-sortIcon field="schoolFPG.name"></p-sortIcon>
                </th>
                <th pSortableColumn="guideName">{{translations.lbl_guide_imparts}}<p-sortIcon field="guideName"></p-sortIcon></th>
                <th pSortableColumn="statusName">{{translations.lbl_status}}<p-sortIcon field="statusName"></p-sortIcon></th>
                <th pSortableColumn="schoolFPG.planedDate">{{translations.lbl_planned_date}}<p-sortIcon
                        field="schoolFPG.planedDate"></p-sortIcon></th>
                <th pSortableColumn="storeName">{{translations.lbl_coordination}}<p-sortIcon field="storeName"></p-sortIcon></th>
                <th pSortableColumn="stagesName">{{translations.lbl_workshops_stages}}<p-sortIcon field="stagesName"></p-sortIcon>
                </th>

                <th></th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-data>
            <tr [pSelectableRow]="data">
                <td>{{data.schoolFPG.schoolId}}</td>
                <td>{{data.schoolFPG.year}} - {{data.schoolFPG.period}}</td>
                <td>{{data.schoolFPG.name}}</td>
                <td>{{data.churchName}}</td>
                <td>{{data.guideName}}</td>                
                <td>{{data.statusName}}</td>
                <td>{{formatDate(data.schoolFPG.planedDate)}}</td>
                <td>{{data.storeName}}</td>
                <td>
                    <button pButton pRipple icon="pi pi-user-plus" class="p-button-rounded p-button-success p-mr-2"
                        (click)="openSchoolFpgParticipant(data)" pTooltip="{{translations.lbl_sign_up}}"></button>
                    <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-mr-2"
                        *ngIf="data.schoolFPG.status!='C' && data.schoolFPG.status!='S' && data.schoolFPG.status!='D'"
                        (click)="openSchoolFpgDetail(data)" pTooltip="{{translations.lbl_edit}}"></button>
                    <button pButton pRipple icon="pi pi-search" class="p-button-rounded p-button-secondary p-mr-2"
                        *ngIf="data.schoolFPG.status=='C' || data.schoolFPG.status=='S' || data.schoolFPG.status=='D'"
                        (click)="openSchoolFpgDetail(data)" pTooltip="{{translations.lbl_select}}"></button>
                    <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger"
                        *ngIf="data.schoolFPG.status!='C' && data.schoolFPG.status!='D' && data.schoolFPG.status!='A'" (click)="deleteSchoolFpg(data)"
                        pTooltip="{{translations.lbl_delete}}"></button>
                    <button pButton pRipple icon="pi pi-check-circle" class="p-button-rounded p-button-success p-mr-2"
                        *ngIf="data.schoolFPG.status=='A' || data.schoolFPG.status=='D' || data.schoolFPG.status=='C'"
                        (click)="showDialogStatus(data)" pTooltip="{{translations.lbl_status}}"></button>
                </td>
            </tr>
        </ng-template>



        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                {{translations.lbl_total}} {{lstSchoolsFpg ? lstSchoolsFpg.length: 0}} {{translations.lbl_records}}
            </div>
        </ng-template>
    </p-table>
</div>

<p-dialog header="{{translations.lbl_change}} {{translations.lbl_status}}"  [(visible)]="displayModalStatus" styleClass="p-fluid" [modal]="true"
    [style]="{width: '50vw'}" [maximizable]="true" [baseZIndex]="10000" [draggable]="false" [resizable]="false">

    <div class="card">
        <!-- MAIN CONTENT -->
        <div class="p-grid">
            <!-- INFO -->
            <div class="p-col-12">
                <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1">
                    <span>{{translations.lbl_coordination}}</span>
                    <span class="p-text-bold">{{schoolSelected != null ? schoolSelected.schoolFPG.storeId+ "
                        "+schoolSelected.storeName
                        :""}}</span>
                </div>
                <div class="subTitle  p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{translations.lbl_school_prep_guides}}</span>
                    <span class="p-text-bold">{{schoolSelected != null ? schoolSelected.schoolFPG.schoolId+ "
                        "+schoolSelected.schoolFPG.name
                        :""}}</span>
                </div>
                <div class="subTitle p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{translations.lbl_status}}</span>
                    <span class="p-text-bold">{{schoolSelected != null ?schoolSelected.statusName :
                        ""}}

                    </span>
                </div>

            </div>
        </div>
        <!-- INPUTS -->
        <div class="p-grid">
            <!-- 1ST SECTION INFO -->
            <div class="p-col-12">

                <div class="p-fluid">

                    <div class="p-col-12">
                        <label for="statusModal">{{translations.lbl_select}} {{translations.lbl_new}} {{translations.lbl_status}} <span *ngIf="!statusSelected"
                                style="color:red">(*)</span></label>
                        <p-dropdown id="statusModal" [options]="SchoolTranStsList" [(ngModel)]="statusSelected"
                            placeholder="{{translations.lbl_select}} {{translations.lbl_status}}" optionLabel="value"
                            [showClear]="true"></p-dropdown>
                    </div>

                    <!-- Name -->
                    <div class="p-col-12">
                        <label for="dateModal">{{translations.lbl_date}} <span *ngIf="!dateSelected" style="color:red">
                                (*)</span></label>
                        <p-inputMask id="dateModal" slotChar="DD/MM/YYYY"
                            pattern="^(0[1-9]|1[0-9]|2[0-9]|3[0-1])/(0[1-9]|1[0-2])/(\d{4})$" mask="99/99/9999"
                            [(ngModel)]="dateSelected" placeholder="DD/MM/YYYY"></p-inputMask>

                    </div>

                    <!-- Comments -->
                    <div class="p-col-12">
                        <label for="commentsModal">{{translations.lbl_comments}} <span *ngIf="!commentsSelected" style="color:red">
                                (*)</span></label>
                        <textarea id="commentsModal" [(ngModel)]="commentsSelected" rows="5" cols="30" pInputTextarea
                            autoResize="autoResize" maxlength="300" #myInput></textarea>
                        <label class="nopadding clrlbl">{{myInput.value.length}} / 300 </label>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">

        <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
            (click)="displayModalStatus=false"></button>

        <button pButton pRipple type="button" icon="pi pi-check" label="{{translations.lbl_save}}"
            class="p-button-raised p-button-success" (click)="updateStatus()"></button>
    </ng-template>
</p-dialog>